import { useCallback, useEffect, useState } from 'react';

export type ProductKey = 'THERESUME' | 'THERECRUIT';
const PRODUCT_KEY = 'admin_product';
// Lets every page follow the product switch in the sidebar without a reload.
const PRODUCT_EVENT = 'admin-product-change';

export function useAdminProduct(defaultValue: ProductKey = 'THERECRUIT') {
  const [product, setProductState] = useState<ProductKey>(() => (localStorage.getItem(PRODUCT_KEY) as ProductKey) || defaultValue);

  useEffect(() => {
    const sync = () => setProductState((localStorage.getItem(PRODUCT_KEY) as ProductKey) || defaultValue);
    window.addEventListener(PRODUCT_EVENT, sync);
    return () => window.removeEventListener(PRODUCT_EVENT, sync);
  }, [defaultValue]);

  const setProduct = useCallback((next: ProductKey) => {
    localStorage.setItem(PRODUCT_KEY, next);
    setProductState(next);
    window.dispatchEvent(new Event(PRODUCT_EVENT));
  }, []);

  return { product, setProduct } as const;
}
